import type { ClientAttachmentSettingsBootstrapAction } from './actions.types';

type ClientAttachmentSettingsBootstrap = (
  payload: ClientAttachmentSettingsBootstrapAction['payload']
) => ClientAttachmentSettingsBootstrapAction;
export const clientAttachmentSettingsBootstrap: ClientAttachmentSettingsBootstrap = (payload) => ({
  type: 'CLIENT_ATTACHMENT_SETTINGS.BOOTSTRAP',
  payload,
});
